/**
 * Values offered by the Organisations quick filters for the OPQRY Enum fields, with the label keys the organisation
 * screens already use. OPQRY's metadata carries no enum values: a member added to OPHUB's `OrganisationStatus`,
 * `LegalStatus` or `OrganisationType` shows here only once it is added below. `Deleted` is internal and never offered.
 */
export const ORGANISATION_FILTER_VALUES = {
    status: [
        { id: "Active", labelKey: "organisation.status.Active" },
        { id: "Inactive", labelKey: "organisation.status.Inactive" },
        { id: "InLiquidation", labelKey: "organisation.status.InLiquidation" },
        { id: "Closed", labelKey: "organisation.status.Closed" },
    ],
    legalStatus: [
        { id: "Active", labelKey: "organisation.legalStatus.Active" },
        { id: "Dissolved", labelKey: "organisation.legalStatus.Dissolved" },
        { id: "InLiquidation", labelKey: "organisation.legalStatus.InLiquidation" },
        { id: "Ceased", labelKey: "organisation.legalStatus.Ceased" },
    ],
    organisationType: [
        { id: "Entreprise", labelKey: "organisation.detail.options.organisationType.Entreprise" },
        { id: "OSBL", labelKey: "organisation.detail.options.organisationType.OSBL" },
        { id: "Fondation", labelKey: "organisation.detail.options.organisationType.Fondation" },
    ],
};
